'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawers = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _pushCartActions = require('../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _listeners = require('../../utils/listeners');

var _functional = require('../../utils/functional');

var _drawer = require('./drawer');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var matches = {
  trigger: '[data-module-drawers-trigger]',
  close: '[data-module-drawers-close]',
  backdrop: '.js-Drawers_Backdrop'
};

var els = {
  body: document.body || document.documentElement,
  backdrop: (0, _functional.getElement)(matches.backdrop),
  drawers: (0, _functional.getElement)('.drw-Drawers'),
  trigger: (0, _functional.getElement)('.drw-Mobile_Trigger'),
  tickerEnabled: (0, _functional.getElement)('.hd-Header_MobileMenu-tickerActive'),
  siteContainer: (0, _functional.getElement)('.lyt-Site_Main'),
  siteFooter: (0, _functional.getElement)('.ft-Footer'),
  siteUsps: (0, _functional.getElement)('.ft-Usps')
};
var classes = {
  activeClass: 'drw-Drawers-active',
  activeTriggerClass: 'hd-Mobile_Trigger-active',
  activeTriggerTickerEnabledClass: 'hd-Mobile_Trigger-active',
  activeDrawerClass: 'drw-Drawer-active',
  siteOverflowed: 'util-SiteOverflowed',
  siteMoveRight: 'lyt-Site_Main-moveRight',
  siteMoveLeft: 'lyt-Site_Main-moveLeft',
  siteFooterMoveRight: 'ft-Footer-moveRight',
  siteFooterMoveLeft: 'ft-Footer-moveLeft'
};
var options = {
  openOneAtATime: true
};

var Drawers = exports.Drawers = {
  init: function init() {
    var _this = this;

    var keys = (0, _functional.getElements)('[data-module-drawers-trigger]').map(function (el) {
      return el.dataset.moduleDrawersTrigger;
    });
    var drawers = keys.map(function (key) {
      return _this.createDrawer(key);
    });

    this.keys = keys;
    this.drawers = drawers;
    this.listeners = new _listeners.Listeners();

    this.handleClick = this.handleClick.bind(this);

    this.setupListeners();
  },

  createDrawer: function createDrawer(key) {
    var drawer = (0, _create2.default)(_drawer.Drawer);
    drawer.init({ key: key });

    return drawer;
  },

  setupListeners: function setupListeners() {
    this.listeners.add(els.body, 'click', this.handleClick);
  },

  handleClick: function handleClick(event) {
    var target = event.target;

    var isTrigger = target.closest(matches.trigger) !== null;
    var isClose = target.closest(matches.close) !== null;
    var isBackdrop = target.closest(matches.backdrop) !== null;
    var shouldReturnEarly = isTrigger === false && isClose === false && isBackdrop === false;

    if (shouldReturnEarly) return;

    event.preventDefault();

    if (isTrigger) {
      var trigger = target.closest(matches.trigger);
      var key = trigger.dataset.moduleDrawersTrigger;

      if (this.keys.includes(key)) {
        this.activeDrawerKey = key === this.activeDrawerKey ? '' : key;
      } else {
        this.drawers.push(this.createDrawer(key));
      }
    }

    if (isClose || isBackdrop) {
      this.activeDrawerKey = '';
    }
  },

  get activeDrawerKey() {
    return this._activeDrawerKey;
  },
  set activeDrawerKey(key) {
    var _this2 = this;

    var previousKey = this._activeDrawerKey;
    this._activeDrawerKey = key;

    if (key === '') {
      this.drawers.forEach(function (d) {
        return d.isOpen = false;
      });
    } else {
      var drawer = this.drawers.find(function (d) {
        return d.key === _this2._activeDrawerKey;
      });
      drawer.isOpen = true;

      if (options.openOneAtATime) {
        this.drawers.filter(function (d) {
          return d.key !== _this2._activeDrawerKey;
        }).forEach(function (d) {
          return d.isOpen = false;
        });
      }
    }

    var allDrawersAreClosed = this.drawers.every(function (d) {
      return d.isOpen === false;
    });
    els.drawers.classList.toggle(classes.activeClass, !allDrawersAreClosed);
    els.body.classList.toggle(classes.siteOverflowed, !allDrawersAreClosed);

    if (previousKey === 'cart') {
      window.store.dispatch(pushCartActions.removeAllErrors());
    }

    var drawersThatMoveTheSiteLeft = ['cart', 'product', 'filters', 'collection-description'];
    var drawersThatMoveTheSiteRight = ['menu'];

    if (drawersThatMoveTheSiteRight.includes(key)) {
      els.siteContainer.classList.add(classes.siteMoveRight);
      els.trigger.classList.add(classes.activeTriggerClass);
      els.siteFooter.classList.add(classes.siteFooterMoveRight);
      els.siteUsps.classList.add(classes.siteFooterMoveRight);

      if (!els.tickerEnabled) return;
      els.tickerEnabled.classList.add(classes.activeTriggerTickerEnabledClass);
    } else {
      els.siteContainer.classList.remove(classes.siteMoveRight);
      els.trigger.classList.remove(classes.activeTriggerClass);
      els.siteFooter.classList.remove(classes.siteFooterMoveRight);
      els.siteUsps.classList.remove(classes.siteFooterMoveRight);

      if (!els.tickerEnabled) return;
      els.tickerEnabled.classList.remove(classes.activeTriggerTickerEnabledClass);
    }

    if (drawersThatMoveTheSiteLeft.includes(key)) {
      els.siteContainer.classList.add(classes.siteMoveLeft);
      els.siteFooter.classList.add(classes.siteFooterMoveLeft);
      els.siteUsps.classList.add(classes.siteFooterMoveLeft);
    } else {
      els.siteContainer.classList.remove(classes.siteMoveLeft);
      els.siteFooter.classList.remove(classes.siteFooterMoveLeft);
      els.siteUsps.classList.remove(classes.siteFooterMoveLeft);
    }
  }
};